import type { APICommonResponse } from 'src/types/common.types';
import { BOARD_TYPE } from 'src/utils/contants';
import utils from 'src/utils/utils';

import { axiosInstance } from '@/store/server/common/client';

import type {
  GetFaqDetailRequest,
  GetFaqDetailResponse,
  GetFaqListRequest,
  GetFaqListResponse,
  GetNoticeDetailRequest,
  GetNoticeDetailResponse,
  GetNoticeListRequest,
  GetNoticeListResponse,
  GetQnaDetailRequest,
  GetQnaDetailResponse,
  GetQnaListRequest,
  GetQnaListResponse,
  WriteInquiryRequest,
  WriteInquiryResponse,
} from './support.dto';

export const supportService = {
  // 공지사항 목록 조회
  getNoticeList: async (params: GetNoticeListRequest): Promise<APICommonResponse<GetNoticeListResponse>> => {
    return axiosInstance.market.public.get('/mypage/info/notice', {
      params,
    });
  },

  // 공지사항 상세 조회
  getNoticeDetail: async (params: GetNoticeDetailRequest): Promise<APICommonResponse<GetNoticeDetailResponse>> => {
    return axiosInstance.market.public.get(`/mypage/info/notice/${params.bbs_seq}`, {});
  },

  // FAQ 목록 조회
  getFaqList: async (params: GetFaqListRequest): Promise<APICommonResponse<GetFaqListResponse>> => {
    return axiosInstance.market.public.get('/mypage/info/faq', {
      params,
    });
  },

  // FAQ 상세 조회
  getFaqDetail: async (params: GetFaqDetailRequest): Promise<APICommonResponse<GetFaqDetailResponse>> => {
    return axiosInstance.market.public.get(`/mypage/info/faq/${params.bbs_seq}`, {});
  },

  // QNA 목록 조회
  getQnaList: async (params: GetQnaListRequest): Promise<APICommonResponse<GetQnaListResponse>> => {
    return axiosInstance.market.private.get('/mypage/info/inquiry', {
      params,
    });
  },

  // QNA 상세 조회
  getQnaDetail: async (params: GetQnaDetailRequest): Promise<APICommonResponse<GetQnaDetailResponse>> => {
    return axiosInstance.market.private.get(`/mypage/info/inquiry/${params.bbs_seq}`, {});
  },

  // 1:1 문의 작성
  writeInquiry: async (params: WriteInquiryRequest): Promise<APICommonResponse<WriteInquiryResponse>> => {
    const bbs_type = BOARD_TYPE.INQUIRY;
    const fix_yn = 'N';
    const private_yn = 'Y';

    const formData = utils.jsonToFormData({
      bbs_type,
      bbs_div: params.bbs_div,
      subject: params.subject,
      contents: params.contents,
      fix_yn,
      private_yn,
      push_sms: params.push_sms,
      push_email: params.push_email,
    });

    params.bbs_file?.forEach((file: File) => {
      formData.append('bbs_file', file);
    });

    return axiosInstance.market.private.post('/mypage/info/inquiry', formData, {
      headers: {
        contextType: 'multipart/form-data',
      },
    });
  },
};
